export const initializePhoneNumberInput = (
  phoneNumberInput: HTMLInputElement,
  countryCodeInput?: HTMLInputElement
) => {
  phoneNumberInput.addEventListener("blur", e => {
    if (e.currentTarget) {
      const target = e.currentTarget as HTMLInputElement;

      if (target.value.startsWith("0")) {
        phoneNumberInput.value = phoneNumberInput.value.substring(1);
      }

      const countryCode = countryCodeInput?.value;

      if (countryCode) {
        if (target.value.startsWith(countryCode)) {
          phoneNumberInput.value = phoneNumberInput.value.substring(countryCode.length);
        }
      }
    }
  });
};
